import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { hasTenantRealm, resolveTenantCodeFromSearch } from '@/lib/auth/config'
import { KeyRound } from 'lucide-react'

export function LoginPage() {
  const { login, isAuthenticated, isLoading } = useAuth()
  const navigate = useNavigate()
  const tenantCode = resolveTenantCodeFromSearch(window.location.search, null)
  const isTenantScopedLogin = hasTenantRealm(tenantCode)

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard', { replace: true })
    }
  }, [isAuthenticated, navigate])

  if (isLoading) {
    return (
      <div className="flex items-center justify-center">
        <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    )
  }

  return (
    <Card className="shadow-xl shadow-black/10">
      <CardHeader className="text-center">
        <CardTitle className="text-2xl font-display">
          {tenantCode ? `Sign in to ${tenantCode}` : 'Sign in to SPECTREIQ'}
        </CardTitle>
        <CardDescription className="mt-2">
          {isTenantScopedLogin && tenantCode
            ? `${tenantCode} tenant access`
            : 'Platform access'}
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <Button
          onClick={login}
          className="w-full h-12 text-base font-medium"
          variant="glow"
        >
          <KeyRound className="w-5 h-5 mr-2" />
          {tenantCode ? `Sign in to ${tenantCode}` : 'Sign in with CAC / SSO'}
        </Button>

        <div className="text-center text-sm text-muted-foreground">
          {isTenantScopedLogin && tenantCode && (
            <p className="text-xs uppercase tracking-widest">
              Tenant Context: {tenantCode}
            </p>
          )}
        </div>
      </CardContent>
    </Card>
  )
}
